<div
  style="overflow-y: auto"
  mdbModal
  id="loanAgreementModal"
  #loanAgreementModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="loanAgreementModal"
  aria-hidden="true"
  (close)="showHideModal(false)"
  [config]="{ ignoreBackdropClick: true, isNested: true }"
>
  <div class="modal-dialog modal-med" role="document">
    <div class="modal-content">
      <div class="card-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="loanAgreementModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title">Loan Agreement Document</h4>
      </div>
      <div class="card-body">
        <form [formGroup]="loanAgreementForm" (ngSubmit)="submitHandler()">
          <div class="md-form">
            <div class="d-flex justify-content-center mb-4">
              <h5 class="mr-3">Borrower:</h5>
              <h5 class="font-weight-bold">{{ borrowerFullName }}</h5>
            </div>

            <div class="d-flex justify-content-center">
              <h5 class="mr-3">Lender:</h5>
              <h5 class="font-weight-bold">{{ lenderFullName }}</h5>
            </div>

            <hr class="m-4" />
            <div class="d-flex justify-content-center">Amount:</div>
            <div class="d-flex justify-content-center">
              <div class="col-6">
                <input mdbInput mdbValidate id="txtAmount" name="txtAmount" formControlName="Amount" type="number" class="form-control" />
              </div>
            </div>

            <div class="d-flex justify-content-center mt-3">Date Of Transaction:</div>
            <div class="d-flex justify-content-center">
              <div class="col-6">
                <input
                  mdbInput
                  mdbValidate
                  id="txtDateOfTransaction"
                  name="txtDateOfTransaction"
                  formControlName="DateOfTransaction"
                  type="date"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="card-footer d-sm-flex" style="justify-content: end">
        <app-loading [busy]="submitting" [busyText]="'Sending...'"></app-loading>

        <ng-container *ngIf="submitting === false">
          <button type="button" mdbBtn color="trakly-action" class="relative waves-light" (click)="submitHandler()">Send</button>
          <button type="button" mdbBtn color="trakly" class="relative waves-light" (click)="loanAgreementModal.hide()">Close</button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
